import React from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'
import { useHistory } from 'react-router'

import { ReactComponent as MedicalEvaluationCompletedIcon } from 'static/svg/medical-evaluation-completed-icon.svg'

import { DASHBOARD_HOME_PATIENT } from 'settings/_routesSettings'

import * as S from './styles'

const PatientAlreadyCompletedMessage = (): JSX.Element => {

  const history = useHistory()

  return (
    <S.Container>
      <MedicalEvaluationCompletedIcon />
      <Typography variant='content2' customClassName='PatientAlreadyCompletedMessage__Message'>
        Sua avaliação de saúde emocional já foi preenchida. <br /> Avisaremos quando houver a próxima.
      </Typography>
      <Button variant='contained' onClick={() => history.push(DASHBOARD_HOME_PATIENT)}>
        IR PARA O INÍCIO
      </Button>
    </S.Container>
  )
}

export default PatientAlreadyCompletedMessage